@if(loader){
<app-loader></app-loader>
}
<p-card>
    <form [formGroup]="createProductForm">
        <div class="grid mb">
            <div class="col">
                <div class="field">
                      <br>
                <div class="field text-left">
                    <label for="IsServiceType" class="label-required display">Type</label>
                   <div style="display: flex; gap: 1rem; align-items: center;">
                     <label>
                        <input type="radio" formControlName="IsServiceType" value="N" />
                        Goods
                    </label>
            
                    <label>
                        <input type="radio" formControlName="IsServiceType" value="Y" />
                        Service
                    </label>
                   </div>
                </div>
                    <label for="website">Product Code</label>
                    <div class="flex align-items-center">
                        <input pInputText type="text" readonly formControlName="ProductCode" />
                    </div>
                </div>

                <div class="field">
                    <label for="website">Product Name</label>
                    <input pInputText placeholder="e.g Iphone 15 Pro" readonly formControlName="ProductName" />
                </div>

                <!-- <div class="field">
                    <label for="website">Product Description</label>
                    <input pInputText formControlName="ProductDescription" readonly
                        placeholder="e.g Powerful iPhone innovation" />
                </div> -->
                  <div class="field text-left" style="margin-top: 0px;">
                    <label for="website">Product Specification / Grade</label>
                    <input pInputText formControlName="ProductSpecification"  readonly
                      class="w-full p-inputtext-sm" />
                </div>
            </div>
            <div class="col">
                
                <div class="flex align-items-center mt-4">
                    
                    <div class="flex align-items-center">
                        <p-checkbox label="Active" formControlName="isactive" [binary]="true"></p-checkbox>
                    </div>
                    <div class="flex align-items-center">
                        <p-checkbox label="Taxable" formControlName="IsTaxable" value="true" [readonly]="iseditProduct || !iseditProduct" 
                            [binary]="true"></p-checkbox>
                    </div>
                    <div class="flex align-items-center">
                        <p-checkbox label="Inventory" formControlName="IsInventory" [binary]="true"
                            value="true"></p-checkbox>
                    </div>
                </div><br>
                <!-- <div class="flex align-items-center pd1">
                    <div class="flex align-items-center">
                        <p-checkbox label="Can be Purchased" formControlName="CanBePurchased" [binary]="true" value="true" ></p-checkbox>
                    </div>
                    <div class="flex align-items-center">
                        <p-checkbox formControlName="CanBeSold" [binary]="true" label="Can be Sold" value="true" ></p-checkbox>
                    </div>
                    <div class="flex align-items-center">
                        <p-checkbox label="Can be Rented" formControlName="CanBeRented" [binary]="true" value="true" ></p-checkbox>
                    </div>
                </div><br> --><br><br>
                <div class="flex align-items-center">
                    <div class="flex align-items-center">
                        <p-checkbox label="Lot Controlled" formControlName="isLotTracking" [binary]="true"
                            value="true"></p-checkbox>
                    </div>
                    <div class="flex align-items-center">
                        <p-checkbox label="Inventory By Location?" formControlName="isLocationTracking" [binary]="true"
                            value="true"></p-checkbox>
                    </div>
                    <div class="flex align-items-center">
                        <p-checkbox label="Serial Tracking" formControlName="isSerialTracking" [binary]="true"
                            value="true"></p-checkbox>
                    </div>
                </div><br>

                <div class="field mt-1">
                    <!-- <fieldset class="field-setting">
                        <b>
                            <legend>Price Setting</legend>
                        </b>
                        <p-radioButton value="Qty" inputId="CostCalculation1" formControlName="CostCalculation"
                            class="radio-button"></p-radioButton>
                        <label for="CostCalculation1">By Quantity</label>

                        <p-radioButton value="Wgt" inputId="CostCalculation2" formControlName="CostCalculation"
                            class="radio-button"></p-radioButton>
                        <label for="CostCalculation2">By Weight</label>
                    </fieldset> -->

                     <div class="field mt-0" style="display: flex; gap: 10px;">
                    <div class="field text-left" style="flex: 1;">
                        <label for="tags" class="bold-label">Product Size</label>
                        <input formControlName="ProductSize" pInputText placeholder="" class="input-field"  readonly />
                    </div>
                    
                    <div class="field text-left" style="flex: 1;">
                        <label for="Weight">Weight</label>
                        <input pInputText formControlName="Weight" class="w-full p-inputtext-sm" style="height: 40px; padding: 5px;"  readonly/>
                    </div>
                </div>
      <div class="field">
                    <label for="website">Product Description</label>
                    <input pInputText formControlName="ProductDescription" readonly
                        placeholder="e.g Powerful iPhone innovation" />
                </div>
                </div>

            </div>

            <div class="col">
                <div class="field">
                    <div class="flex justify-content-end">
                        <input type="file" #fileInput style="display: none">

                        @if (previewImage) {
                        <div style="margin-right: 95px; border: 2px solid; border-radius: 5px;">
                            <p-image [src]="previewImage" alt="Image" width="145px" height="150px"
                                [preview]="true"></p-image>
                        </div>

                        } @else {
                        <label for="fileInput" style="cursor: pointer;" (click)="fileInput.click()">
                            <img src="./assets/upload-logo.jpg" width="100px" alt="Image"
                                style="border: 2px solid; border-radius: 10px;margin-right: 150px;">
                        </label>
                        }

                    </div>
                </div>
            </div>



        </div><br>


        <p-tabView [(activeIndex)]="activeIndex">
            <p-tabPanel header="General Information">
                <div class="grid">
                    <div class="col">
                        <div class="field">
                            <label for="producttypedropdown">Product Type</label>
                            <input formControlName="producttypedropdown" pInputText [readonly]="true"
                                styleClass="w-full" />
                        </div>
                        <div class="field" >
                            <label for="tags">Purchase Cost</label><br>
                            <input formControlName="StandardCost" type="number" readonly pInputText
                                style="width:100%" />
                        </div>
                           <div class="field" >
                            <label for="tags">Sales Price</label><br>
                            <input formControlName="SalesPrice" type="number" readonly pInputText style="width:100%" />
                        </div>
                           <div class="field-group" style="display: flex; justify-content: space-between; gap: 10px; margin-top: 8px;">
                            <div class="field text-left mt-1" style="margin-top: 0;">
                                <label for="hsnCode">HSN/SAC Code</label>
                                <div style="display: flex; align-items: center;">
                                    <input
                                        pInputText
                                        readonly
                                        class="w-full p-inputtext-sm"
                                        formControlName="HSNCode"
                                        [ngClass]="{'ng-invalid ng-dirty': submitted && !this.createProductForm.controls.HSNCode.value}"
                                        style="height: 28px;" />
                                    <div style="margin-left: 8px;">
                                        <!-- <p-button icon="pi pi-search" (click)="getGSTList()" [raised]="true" [size]="'small'" severity="info"></p-button> -->
                                    </div>
                                </div>
                            </div>
                            <div class="field text-left mt-1" style="margin-top: 0;">
                                <label for="gstRate">GST Rate (%)</label>
                                <div style="display: flex; align-items: center;">
                                    <input
                                        pInputText
                                        type="text"
                                        class="w-full p-inputtext-sm"
                                        formControlName="gstRate" readonly
                                        placeholder="GST Rate"
                                    
                                        style="height: 28px;" />
                                </div>
                            </div>
                        </div>
                          <!-- <div class="field"  *ngIf="!hide">
                            <label for="UOM">UOM</label>
                            <input formControlName="UnitsOfMeasure" pInputText [readonly]="true" styleClass="w-full" />
                        </div> -->
                        <!-- <div class="field"  *ngIf="!hide">
                            <label for="UOM">Colour</label>
                            <input formControlName="ColorId" pInputText [readonly]="true" styleClass="w-full" />
                        </div> -->
                        <!-- <div class="field" *ngIf="!hide">
                                <label for="UOM">Product SubCategory</label>
                                <input formControlName="SubCategoryId" pInputText [readonly]="true" styleClass="w-full" />
                        </div> -->
                         <!-- <div class="field"  *ngIf="!hide">
                            <label for="UOM">Product Group</label>
                            <input formControlName="GroupId" pInputText [readonly]="true" styleClass="w-full" />
                        </div> -->
                        <div class="field"  *ngIf="hide">
                            <label for="UOM">Stocking UOM</label>
                            <input formControlName="UnitsOfMeasure" pInputText [readonly]="true" styleClass="w-full" />
                        </div>

                        <div class="field"  *ngIf="hide">
                            <label for="website">Purchase UOM</label>
                            <input formControlName="PurchasingUom" pInputText [readonly]="true" styleClass="w-full" />
                        </div>

                        <div class="field"  *ngIf="hide">
                            <label for="website">Selling UOM</label>
                            <input formControlName="SellingUom" pInputText [readonly]="true" styleClass="w-full" />
                        </div>
                    </div>

                    <div class="col">
                     
 <div class="field"  *ngIf="!hide">
                            <label for="UOM">UOM</label>
                            <input formControlName="UnitsOfMeasure" pInputText [readonly]="true" styleClass="w-full" />
                        </div>

                        <div class="field" *ngIf="!hide">
                            <label for="UOM">Product Group</label>
                            <input formControlName="GroupValue" pInputText [readonly]="true" styleClass="w-full" />
                        </div>

                             <div class="field">
                            <label for="tags">Product Category</label><br>
                            <input formControlName="CategoryValue" pInputText readonly style="width:100%" />
                        </div>
                        <div class="field" *ngIf="!hide">
                            <label for="UOM">Product SubCategory</label>
                            <input formControlName="SubCategoryName" pInputText [readonly]="true" styleClass="w-full" />
                        </div>
                        
                        <!-- <div class="field">
                            <label for="tags">Weight</label><br>
                            <input formControlName="Weight" pInputText readonly style="width:100%" />
                        </div> -->

                        <!-- <div class="field">
                            <label for="tags">Product Category</label><br>
                            <input formControlName="CategoryValue" pInputText readonly style="width:100%" />
                        </div> -->
                    </div>

                    <div class="col">
                        <div class="field">
                            <label for="tags">Primary Vendor</label><br>
                            <input formControlName="VendorName"  readonly pInputText style="width:100%" />
                        </div>
                        <div class="field"  *ngIf="hide">
                            <label for="tags">Barcode</label><br>
                            <input formControlName="Barcode" type="number" readonly pInputText
                                style="width:100%" />
                        </div>
                          <div class="field"  *ngIf="!hide">
                            <label for="UOM">Vendor Product Code</label>
                            <input formControlName="VendorProductCode" pInputText [readonly]="true" styleClass="w-full" />
                        </div>
                             <div class="field">
                    <label for="website">Standard Type</label>
                    <input pInputText formControlName="StandardType" readonly />
                </div>
                    </div>

                </div>
            </p-tabPanel>

        </p-tabView>
    </form>
</p-card>

<p-toast></p-toast>
